import { BAROMETER_AREAS } from 'constants/surveys';
import type { BarometerSpecificAreaKey, SurveyBase } from 'types/surveys';

export const ScoreRange = {
  veryLow: 'veryLow',
  low: 'low',
  medium: 'medium',
  high: 'high',
  fullyCharged: 'fullyCharged',
} as const;

export const ColorByScore = {
  [ScoreRange.veryLow]: 'bg-[var(--color-barometer-danger)]',
  [ScoreRange.low]: 'bg-[var(--color-barometer-warning)]',
  [ScoreRange.medium]: 'bg-[var(--color-barometer-medium)]',
  [ScoreRange.high]: 'bg-[var(--color-barometer-good)]',
  [ScoreRange.fullyCharged]: 'bg-[var(--color-barometer-top)]',
} as const;

export const TOTAL_SEGMENTS = 5;
export const MAX_CHART_RESULTS = 7;
export const MOBILE_MAX_WIDTH_PX = 768;
export const BAROMETER_RESULT_AREAS: readonly BarometerSpecificAreaKey[] = [
  BAROMETER_AREAS.EMOTIONAL,
  BAROMETER_AREAS.RELATIONAL,
  BAROMETER_AREAS.PROFESSIONAL,
  BAROMETER_AREAS.HEALTH,
];

export interface AreaScore {
  score: number;
  maxScore: number;
}

export interface BarometerData {
  [BAROMETER_AREAS.GENERAL]: AreaScore;
  [BAROMETER_AREAS.EMOTIONAL]: AreaScore;
  [BAROMETER_AREAS.PROFESSIONAL]: AreaScore;
  [BAROMETER_AREAS.RELATIONAL]: AreaScore;
  [BAROMETER_AREAS.HEALTH]: AreaScore;
}

export interface BarometerResponse extends SurveyBase {
  scorePerTag?: Record<string, number>;
  maxScorePerTag?: Record<string, number>;
  maxSurveyScore?: number;
}
